<template>
  <div class="search-bar-box">
    <v-text-field dense label="Rechercher" v-on:change="searchTextChanged()"
      hide-details type="text" :placeholder="placeholder" 
      prepend-inner-icon="mdi-magnify" class="search-bar"
      v-model="searchText">
    </v-text-field>
  </div>
</template>

<style scoped>
  .search-bar-box {
    padding: 10px 4px;
  }

  .search-bar {
    border-style: unset;
    border-width: 0 0px 1px 0px;
    padding-bottom: 5px;
  }
</style>


<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


  /**
   * @desc barre de recherche pour filtrer les articles
   */
  @Component({
    components: {},
  })
  export default class SearchBar extends Vue {
    @Prop({default: "recherche"})
    placeholder? : string;

    searchText = "";

    /**
     * @desc envoie un msg événement pour indiquer un changement dans le texte inscrit
     */
    searchTextChanged() : void {
      this.$emit('filterSearchText', this.searchText);
    }
  }
</script>
